import React from 'react';

import './ChevronIcon.scss';

interface IIconProps {
  direction: string;
}

const ChevronIcon = ({ direction }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fillRule="evenodd"
      id="ki-chevron-left"
      className={`chevron-icon chevron-icon--${direction}`}
    >
      <path fill="#fff" d="M24 4L12 16l12 12-2 2L8 16 22 2z"></path>
    </svg>
  );
};

export default ChevronIcon;
